@if (show()) {
  <header
    id="topo-app-header"
    [attr.data-theme]="theme()"
    [style.color]="textColor()">
    <div class="logo-container">
      <topo-logo-svg
        [color]="textColor()"
        [size]="40" />

      @if (!!orgClientLogo()) {
        <div class="vertical-divider"></div>
        <img
          [src]="orgClientLogo()"
          style="height: 40px; max-width: 120px" />
      }

      @if (!!label()) {
        <div class="vertical-divider"></div>
        <span>{{ label() | translate }}</span>
      }
    </div>

    <div class="content-container">
      <ng-template #content />
    </div>

    @let isReadOnlyUser = userContext()?.isReadOnlyToken;

    @if (showMenus() || isReadOnlyUser) {
      <div class="menu-container">
        @if (isReadOnlyUser) {
          <a
            class="button is-secondary"
            routerLink="/login">
            {{ 'MAP.LOG-IN' | translate }}
          </a>
        } @else if (showMenus()) {
          <topo-app-help [theme]="theme()" />

          @if (!isSideNavEnabled()) {
            <topo-app-header-menu [theme]="theme()" />
          }

          @if (showNotifications()) {
            <topo-notification-header-button [theme]="theme()" />
          }

          <topo-profile-menu class="pl-xs" />
        }
      </div>
    }
  </header>
}
